import { API_ROOT } from '../../config/config'
import { doDownload, doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9012/api'

// ประวัติการติดตามโครงการ
export const getTrackingHistory = (projectCode, projectVersionId) => {
  const url = `${API_ROOT}/subproject/subproject-tracking/history/page?projectCode=${
    projectCode || ''
  }&projectVersionId=${projectVersionId || ''}`

  return doGet(url)
}

// ติดตามโครงการ
export const getTracking = (projectCode, projectVersionId, id) => {
  const url = `${API_ROOT}/subproject/subproject-tracking?projectCode=${
    projectCode || ''
  }&projectVersionId=${projectVersionId || ''}&id=${id || ''}`

  return doGet(url)
}

export const saveTracking = (request) => {
  const url = `${API_ROOT}/subproject/subproject-tracking`

  return doPost(url, request)
}

export const saveTrackingAttach = (request) => {
  const url = `${API_ROOT}/subproject/subproject-tracking/attach`

  return doPost(url, request)
}

export const saveTrackingDetail = (request) => {
  const url = `${API_ROOT}/subproject/subproject-tracking/detail`

  return doPost(url, request)
}

export const downloadTrackingFile = (id) => {
  // let API_ROOT = 'http://localhost:9009/api'
  const url = `${API_ROOT}/files/subproject/follow/${id}/form`

  return doDownload(url)
}

export const copyTracking = (id) => {
  const url = `${API_ROOT}/subproject/subproject-tracking/copy/${id}`

  return doGet(url)
}
